/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { memo, useEffect, useRef } from "react";
import KeyboardIcon from "@material-ui/icons/Keyboard";
import { HintField, LabelField } from "components";
import CopyButton from "components/CopyButton/CopyButton";
import "../../../style.scss";
import { fontConfig } from "theme/fontConfig";

export const InputField = memo(
  ({
    icon,
    setFieldsData,
    memberInfo,
    title,
    name,
    useref,
    style,
    formStyle,
    type,
    step,
    rules,
    placeholderIcon,
    error,
    formik,
    checkValidation = false,
    mandatory = false,
    handleChange,
    setOpenKeyboard,
    openKeyboard,
    inputClassName,
    min,
    onClick,
    onKeyDown,
    batchreview,
    className,
    paymentInput,
    titleStyle,
    copy,
    inputRef,
    onBlur = null,
    getTouch,
    notIcon,
    ...rest
  }) => {
    const ref = useRef(null);

    useEffect(() => {
      if (useref) ref.current.focus();
    }, []);

    const getInputClasses = () => {
      if (!checkValidation) {
        return "";
      }

      if (getTouch && error && !notIcon) {
        return "is-invalid";
      }

      if (getTouch && !error) {
        return "is-valid";
      }

      return "";
    };
    return (
      <div
        className={
          memberInfo
            ? `form-group fv-plugins-icon-container  member-info-form`
            : batchreview
            ? `form-group fv-plugins-icon-container batchreview `
            : paymentInput === "paymentInput"
            ? `form-group fv-plugins-icon-container payment-methods-input`
            : title === `none`
            ? `form-group fv-plugins-icon-container ledger-name-input`
            : `form-group fv-plugins-icon-container mb-0`
        }
        style={{ ...formStyle }}
      >
        {title === "none" ? (
          ""
        ) : (
          <LabelField
            className={memberInfo ? "member-info-form-lable" : ""}
            htmlFor={name}
            title={title}
            mandatory={mandatory}
            style={titleStyle}
          />
        )}
        {icon}
        <form
          className="d-flex position-relative"
          style={{
            background: style?.background ? style?.background : "#F3F6F9",
            borderRadius: "6px",
          }}
        >
          <input
            ref={inputRef || ref}
            onWheel={(e) => e.target.blur()}
            style={
              paymentInput
                ? {
                    ...style,
                    height: "48px",
                    fontFamily: fontConfig.GeneralFormControlSolidFont.family,
                    fontSize: "14px",
                    fontWeight: "700",
                  }
                : { height: "48px", ...style }
            }
            id={name}
            type={type}
            min={min}
            step={step}
            onKeyDown={onKeyDown}
            disabled={rest?.disabled}
            className={`main__input-field form-control form-control-solid py-5 px-6 ${getInputClasses()} ${inputClassName} ${
              copy ? "pr-10" : ""
            }`}
            {...rest}
            {...formik?.getFieldProps(name)}
            onChange={handleChange ?? formik?.handleChange}
            value={rest.value}
            autoComplete={rest?.autoComplete || "off"}
            onClick={rest?.handleFocus}
            onBlur={onBlur}
          />
          {name === "hebrew_name" && (
            <KeyboardIcon
              fontSize="large"
              style={{
                cursor: "pointer",
                alignSelf: "center",
                marginRight: "5px",
              }}
              onClick={() => {
                setOpenKeyboard(!openKeyboard);
              }}
            />
          )}
          {!!(rest?.value && rest?.value?.toString()?.trim() && copy) && (
            <CopyButton value={rest.value} />
          )}
          {placeholderIcon}
        </form>

        {getTouch && error ? <HintField error={error} /> : null}
      </div>
    );
  }
);
